var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"diviser"},[_vm._v(" Características ")]),_c('div',{staticClass:"m-t"},[_c('tags',{staticClass:"bem-tags"})],1),_c('bem-campo-secao',{attrs:{"secao":"caracteristica"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }